import React, { createContext, useCallback, useContext, useState } from "react";

interface NavbarPortalContextValue {
    portalTarget: HTMLElement | null;
    setPortalTarget: (element: HTMLElement | null) => void;
}

const NavbarPortalContext = createContext<NavbarPortalContextValue | null>(null);

export const NavbarPortalProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);

    const handleSetPortalTarget = useCallback((element: HTMLElement | null) => {
        setPortalTarget(element);
    }, []);

    return (
        <NavbarPortalContext.Provider
            value={{ portalTarget, setPortalTarget: handleSetPortalTarget }}>
            {children}
        </NavbarPortalContext.Provider>
    );
};

export const useNavbarPortal = () => {
    const context = useContext(NavbarPortalContext);
    if (!context) {
        return { portalTarget: null, setPortalTarget: () => {} };
    }
    return context;
};
